<template>
  <v-dialog v-model="show" width="464" content-class="popup-wrap-1">
    <div class="pa-9">
      <v-form ref="form">
        <div class="search-1">
          <div class="input relative flex-grow-1">
            <v-text-field
              label="광고주 / 그룹사명"
              class="input-custom-1 searchInput"
              height="40px"
              solo
              :value="serchText"
              @input="searchAdvertiser"
              @keypress.enter.prevent="searchAdvertiser"
            ></v-text-field>
            <v-btn icon class="btn">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </div>
        </div>

        <p class="title-type-4">검색 결과</p>

        <div class="white rounded" style="height: 200px; border: 1px solid red">
          <template v-if="this.loading">
            <v-progress-circular
              indeterminate
              color="yellow"
              style="
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%);
              "
            ></v-progress-circular>
          </template>
          <vue-scroll class="list-wrap">
            <v-radio-group v-model="radioColumn" column class="mt-0 pt-6 pl-6">
              <v-radio
                v-for="(item, index) in this.adviertiers"
                :key="item.index"
                :label="item.name"
                :value="item.name"
                color="#fecd00"
                class="radio-type-1 list-row"
              ></v-radio>
            </v-radio-group>
            <div class="no-matching">No matching data.</div>
          </vue-scroll>
        </div>
      </v-form>

      <div class="d-flex justify-end mt-6">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-2"
          @click.stop="clear"
        >
          취소
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1 ml-2"
          @click.prevent="update"
        >
          저장
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { advertiserList } from '@/api/advertiser';
export default {
  props: {
    value: Boolean,
  },
  components: {},
  data: () => ({
    radioColumn: '',
    serchText: '',
    loading: false,
    adviertiers: [],
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    update() {
      this.show = false;
      const advertiserMap = {};
      (this.adviertiers || []).forEach(item => {
        advertiserMap[item.name] = item;
      });
      this.$emit('select:advertiser', advertiserMap[this.radioColumn]);
    },
    clear() {
      let input = document.querySelector('.searchInput input');
      input.value = '';

      this.$refs.form.reset();
      this.show = false;
    },
    searchAdvertiser() {
      let input = document.querySelector('.searchInput input');
      let filter = input.value.toUpperCase();
      let list = document.querySelectorAll('.list-row');
      for (let i = 0; i < list.length; i++) {
        let label = list[i].getElementsByTagName('label')[0];
        let txtValue = label.textContent || label.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          list[i].style.display = '';
        } else {
          list[i].style.display = 'none';
        }
      }
      const listArray = Array.from(list);
      let displayNone = listArray.filter(ele => {
        return ele.style.display === 'none';
      });

      let displayNoneCount = displayNone.length;
      if (displayNoneCount === list.length) {
        document.querySelector('.list-wrap .no-matching').style.display =
          'block';
      } else {
        document.querySelector('.list-wrap .no-matching').style.display =
          'none';
      }
    },
    async getAdvertisers() {
      try {
        const { data } = await advertiserList();
        (data.list || []).forEach(item => {
          if (item.type === 'advertiser' || item.type === 'internal') {
            this.adviertiers.push(item);
          }
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error.response);
      }
    },
  },
  created() {
    this.loading = true;
    this.getAdvertisers();
  },
  mounted() {},
};
</script>

<style scope>
.no-matching {
  display: none;
  text-align: center;
  margin-top: -20px;
  font-size: 14px;
}
</style>
